import * as React from 'react';
import ReactPlayer from 'react-player';

interface VideoConfig {
  url: string;
  width?: number;
  height?: number;
}

export default function Video(props: VideoConfig) {
  // [{ src: this.props.category.preview_file, type: 'video/mp4' }];
  return (
    <ReactPlayer
      url={props.url}
      playing={true}
      controls={true}
      loop={false}
      width={props.width}
      height={props.height}
    />
  );
}
